import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";
import React from "react";
interface LockButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  record?: any;
}

function LockButton({ disabled, onClick, record }: LockButtonProps) {
  return (
    <Tooltip
      placement="bottom"
      title={record.lockedUser ? record.lockedUser : ""}>
      <button
        disabled={disabled}
        className="button action"
        onClick={onClick}>
        <FontIcon iconName="Lock" />
      </button>
    </Tooltip>
  );
}

export default LockButton;
